export default {"src":"/_next/static/media/on-boarding-step-three-image.dd6e9992.svg","height":152,"width":197,"blurWidth":0,"blurHeight":0};